import React, { Component } from 'react';
import {Context } from '../../context/context'
import * as d3 from 'd3';
import _ from 'lodash';

class FacetBar extends Component {

  static contextType = Context;

    constructor(props) {
        super(props)
        this.margins = {
            top: 0,
            right: 25,
            bottom: 3,
            left: 0
        };
        this.createBar = this.createBar.bind(this);
        
    }

    componentDidMount() {
      this.createBar();
    }
    
    componentDidUpdate() {
      this.createBar();
    }

    createBar() {        
        var that = this;

        const maxX = 20; //XXXX this should be total of impact chains;
        const node = this.node;
        const width = node.getBoundingClientRect().width;
        const xScale = d3.scaleLinear()
            .domain([0, maxX])
            .range([0, width - this.margins.right]);
        
        d3.select(node).selectAll('*').remove();

        d3.select(node)
            .on('click', function(d) {          
                // prevent from clicking a value
                // without occurrences due to the 
                // filtering
                if(that.props.data.value > 0)
                  that.context.updateFilters({
                    category: that.props.category,
                    key : that.props.data.key
                  });
            })
            .append('rect')
            .data([this.props.data.value])
            .style('stroke', (this.props.data.selected)? 'deeppink' : '#b6d4fe')
            .style('fill', (this.props.data.selected)?
                'deeppink' : '#cfe2ff' 
            )
            .attr('x', 0)
            .attr('y', 0)
            .attr('height', this.props.height - 1)
            .attr('width', d => xScale(d))
            .classed('selected', this.props.data.selected)
        d3.select(node)
            .append('text')
            .attr('alignment-baseline', 'middle')
            .attr('class', 'key')
            .text(
                (this.props.category === 'category_appalto_dimension')?
                    _.truncate(this.props.data.key) : this.props.data.key
            )
            .attr('x', 5)
            .attr('y', (this.props.height / 2) + 1)
            .classed('selected', this.props.data.selected);
        d3.select(node)
            .append('text')
            .attr('alignment-baseline', 'middle')
            .attr('class', 'value')
            //.text(this.props.data.value)
            .text("")
            .attr('x', width)
            .attr('y', (this.props.height / 2))
            .classed('selected', this.props.data.selected);
        d3.select(node)
            .append('line')
            .style('stroke', '#b6d4fe')
            .attr('x1', 0)
            .attr('x2', width)
            .attr('y1', this.props.height)
            .attr('y2', this.props.height);
        
    }

    refCallback = node => {
        if(!node) return;
        
        this.node = node;
        // set the width of the svg once the element
        // is attached to the DOM and we are able to
        // measure its size
        d3.select(this.node)
            //.attr('width', node.parentElement.getBoundingClientRect().width + 30);
            .attr('width', '100%');
    }

    render() {
        return (
            <div className='facet-bar'>
                <svg ref={this.refCallback} height={this.props.height}></svg>
            </div>
        );
    }
}

export default FacetBar